import React, { useEffect } from "react";
import { connect } from "react-redux";
import { isBusy, withActions } from "actionware";
import { getTranslate } from "react-localize-redux";
import { push } from "connected-react-router";

import { bindActionCreators } from "redux";
import { Spin } from "antd";
import HeaderWithArrow from "../../components/headerWithArrow/headerWithArrow";
import ApprovalSettingView from "./setting.jsx";
import AutoApprovalBanner from "./banner.jsx";
import {
  fetchLenderPreferences,
  saveNewPreferenceData,
  resetToggleBannerView,
  toggleBannerView,
} from "./approvalSettingActions.js";
import { toggleConfirmationModal } from "../confirmationModal/confirmationModalActions";
import { modalPopupStates } from "../../common/constants";
import "./setting.less";
import { getProductNameFromCode } from "./utils.js";
import { BANNER_TYPE } from "./constants";

const ApprovalSetting = ({
  resetViewToApprovalPage,
  saveNewPreferenceData,
  translate,
  loading,
  fetchLenderPreferences,
  newPreference,
  currentPreferences,
  toggleConfirmationModal,
  isBannerVisible,
  bannerTitle,
  bannerType,
  resetToggleBannerView,
  toggleBannerView,
}) => {
  const handlePreferenceChange = (
    action,
    productCode,
    isChecked,
    isEditable
  ) => {
    saveNewPreferenceData(action, {
      productCode,
      isChecked,
    });
    if (!isEditable) {
      toggleBannerView({
        showFlag: true,
        title: "autoApproval.lender_admin_snackbar_auto_approval_banner1",
        type: BANNER_TYPE.disableBanner,
      });
    } else {
      toggleConfirmationModal(modalPopupStates.autoApproval);
      resetToggleBannerView();
    }
  };

  const handleBackArrowClick = () => {
    resetToggleBannerView();
    resetViewToApprovalPage();
  };

  useEffect(() => {
    fetchLenderPreferences();
  }, [fetchLenderPreferences]);

  const renderBackArrowNavigation = () => {
    return (
      <HeaderWithArrow
        showArrow={true}
        arrowClicked={() => handleBackArrowClick()}
        title={translate("autoApproval.lender_admin_heading_settings")}
      />
    );
  };

  const renderBanner = () => {
    if (isBannerVisible) {
      const updatedBannerTitle = translate(bannerTitle).replace(
        "${productName}",
        getProductNameFromCode(currentPreferences, newPreference.product_code)
      );
      return (
        <AutoApprovalBanner
          bannerTitle={updatedBannerTitle}
          bannerType={bannerType}
          newPreference={newPreference}
        />
      );
    }
  };

  const renderPageContent = () => {
    return (
      <ApprovalSettingView
        lenderPreferences={currentPreferences}
        handlePreferenceChange={handlePreferenceChange}
        translate={translate}
      />
    );
  };
  if (loading) {
    return <Spin tip={translate("generic.loadingData")} size="large" />;
  } else {
    return (
      <>
        {renderBackArrowNavigation()}
        {renderBanner()}
        {renderPageContent()}
      </>
    );
  }
};

// export default ApprovalSetting

const mapStateToProps = ({
  localize,
  autoApproval: {
    action,
    newPreference,
    currentPreferences,
    isBannerVisible,
    bannerTitle,
    bannerType,
  },
}) => ({
  translate: getTranslate(localize),
  action,
  newPreference,
  currentPreferences,
  isBannerVisible,
  bannerTitle,
  bannerType,
  loading: isBusy(fetchLenderPreferences),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ push }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withActions({
    saveNewPreferenceData,
    fetchLenderPreferences,
    toggleConfirmationModal,
    resetToggleBannerView,
    toggleBannerView,
  })(ApprovalSetting)
);
